import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * The Google Maps API React Component
 * Max M.
 */

const GOOGLE_MAPS_API_VERSION = '3.44';

class GoogleMapsApi extends Component {
  componentDidMount() {
    this.getGoogleMaps();
  }

  getGoogleMaps() {
    if (!this.googleMapsPromise) {
      this.googleMapsPromise = new Promise(resolve => {
        window.resolveGoogleMapsPromise = () => {
          resolve();
          delete window.resolveGoogleMapsPromise;
        };
        // Load the Google Maps API
        const script = document.createElement('script');
        const API = this.props.googleMapApiKey;
        script.src = `https://maps.googleapis.com/maps/api/js?v=${GOOGLE_MAPS_API_VERSION}&key=${API}&libraries=places,geometry&language=en&region=US&callback=resolveGoogleMapsPromise`;
        script.async = true;
        document.body.appendChild(script);
      });
    }
    return this.googleMapsPromise;
  }

  render() {
    return null;
  }
}

GoogleMapsApi.propTypes = {
  googleMapApiKey: PropTypes.string.isRequired
};

export default GoogleMapsApi;



// WEBPACK FOOTER //
// ./src/components/GoogleMapsApi/GoogleMapsApi.js